import axiosTemp from './axiosTemp'

export type UserPreferenceType = 'narrative' | 'view'
export type GridViewPreference = 'matter' | 'time'

export interface ViewPreferenceResponse {
  preference_type: 'view'
  data: {
    view: GridViewPreference | null
  }
  requires_selection: boolean
}

const BASE_PATH =
  '/api/v1.0/accounts/ACCOUNT_ID/users/USER_ID/preferences/PREFERENCE_TYPE/'

export const buildUserPreferencePath = (
  userId: string | number,
  preferenceType: UserPreferenceType
): string =>
  BASE_PATH.replace('USER_ID', String(userId)).replace(
    'PREFERENCE_TYPE',
    preferenceType
  )

export async function fetchUserPreference<TResponse>(
  userId: string | number,
  preferenceType: UserPreferenceType
): Promise<TResponse> {
  const response = await axiosTemp().get(
    buildUserPreferencePath(userId, preferenceType)
  )
  return response.data
}

export async function updateUserPreference<TRequest, TResponse>(
  userId: string | number,
  preferenceType: UserPreferenceType,
  payload: TRequest
): Promise<TResponse> {
  const response = await axiosTemp().put(
    buildUserPreferencePath(userId, preferenceType),
    JSON.stringify(payload)
  )
  return response.data
}

export const fetchViewPreference = (userId: string | number) =>
  fetchUserPreference<ViewPreferenceResponse>(userId, 'view')

export const updateViewPreference = (
  userId: string | number,
  view: GridViewPreference
) =>
  updateUserPreference<{ view: GridViewPreference }, ViewPreferenceResponse>(
    userId,
    'view',
    { view }
  )
